import { Component, OnInit } from '@angular/core'
import { Form } from '@angular/forms'
import { FolderService } from '../folder.service'

@Component({
	selector: 'app-folder-add',
	templateUrl: './folder-add.component.html',
	styleUrls: ['./folder-add.component.scss']
})

export class FolderAddComponent implements OnInit {
	cansubmit: boolean = true
	error: string
	warning: string
	newfolder = {
		name: null
	}
	subfolders: any = {}

	constructor(
		public folder: FolderService,
	) {}

	ngOnInit() {
	}

	createFolder() {
		this.cansubmit = false
		this.folder.createFolder(this.folder.current.id, this.newfolder.name)
	}

	renameFolder() {
		console.log('rename folder')
	}

	check() {
		if (this.newfolder.name.length < 3) return
		this.error = null
		this.warning = null
		this.cansubmit = true
		this.subfolders = {}
		for (let i in this.folder.current.folders) {
			let folder = this.folder.current.folders[i]
			let needle = this.needle(folder)
			this.subfolders[needle] = folder
		}

		let n = this.needle(this.newfolder.name)
		if (this.subfolders[n]) {
			if (this.subfolders[n].toLowerCase() == this.newfolder.name.toLowerCase()) {
				this.error = `A folder named "${this.subfolders[n]}" already exists here. Please use a different name.`
				this.cansubmit = false
			} else {
				this.warning = `This name looks a lot like "${this.subfolders[n]}". You may consider a different name.`
			}
		}
	}

	needle(string: string) {
		return string.replace(/[^a-z0-9]/gi, '').toLowerCase()
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-add/folder-add.component.ts